/**
 * Logger utility que solo imprime en modo desarrollo
 * Los logs se eliminan automáticamente en el build de producción
 */

const isDevelopment = !window.location.hostname.includes('produccion') && 
                      !window.location.hostname.includes('production') &&
                      !window.location.hostname.includes('prod');

export class Logger {
    private static shouldLog(): boolean {
        return isDevelopment;
    }

    public static log(...args: any[]): void {
        if (this.shouldLog()) {
            console.log(...args);
        }
    }

    public static error(...args: any[]): void {
        console.error(...args);
    }

    public static warn(...args: any[]): void {
        if (this.shouldLog()) {
            console.warn(...args);
        }
    }

    public static info(...args: any[]): void {
        if (this.shouldLog()) {
            console.info(...args);
        }
    }

    public static debug(...args: any[]): void {
        if (this.shouldLog()) {
            console.debug(...args);
        }
    }

    public static httpLog(message: string, data?: any): void {
        if (this.shouldLog()) {
            console.log(`[HTTP] ${message}`, data || '');
        }
    }

    public static retryLog(attempt: number, endpoint: string): void {
        if (this.shouldLog()) {
            console.log(`[RETRY] Attempt ${attempt} for ${endpoint}`);
        }
    }

    public static componentLog(component: string, message: string, data?: any): void {
        if (this.shouldLog()) {
            console.log(`[${component}] ${message}`, data || '');
        }
    }
}
